import { render, staticRenderFns } from "./desktopChat.vue?vue&type=template&id=5249c4d7"
import script from "./desktopChat.vue?vue&type=script&lang=js"
export * from "./desktopChat.vue?vue&type=script&lang=js"
import style0 from "./desktopChat.vue?vue&type=style&index=0&id=5249c4d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports